import React from "react";
import { Link } from "react-router-dom";
import { useGetDashboardQuery } from "../../redux/dashboardApi";

import { useTranslation } from "react-i18next";

function Dashboard() {
  const { t } = useTranslation();
  const { data } = useGetDashboardQuery();

  return (
    <section className="section dashboard mb-4">
      <div className="pagetitle">
        <h1>{t('dashboard')}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard">{t('home')}</Link>
            </li>
            <li className="breadcrumb-item active">{t('dashboard')}</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div class="col-lg-4">
          <div class="card info-card sales-card">
            <div class="card-body">
              <h5 class="card-title">{t('total_users')}</h5>

              <div class="d-flex align-items-center">
                <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                  <i class="bi bi-cart"></i>
                </div>
                <div class="ps-3">
                  <h6>{data?.total_user}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
